import React from 'react';
import ImageHolder from '../../ImageHolder';

const ImageView = ({ image }) => {
  return (
    <div className="card_default card_image">
      <div className="wrap_thumb">
        <ImageHolder image={image} />
        <span className="frame_g" />
      </div>
      {
        image.caption.map((tv, idx) =>
          <strong key={idx} className="tit_card">{tv.get('v')}</strong>
        )
      }
    </div>
)};

export default ImageView;



// WEBPACK FOOTER //
// ./src/components/PostBox/media/ImageView.js